import { Combo } from './combo.model';
import { GerenciamentoEvento } from './gerenciamento-evento.model';
//import { EdicaoDiaSemana } from './edicao-dia-semana';

export class Edicao {
    public id: number;
    public titulo: string;
    public data_inicio: Date;
    public data_fim: Date;
    public id_pais: number;
    public id_uf: number;
    public id_cidade: number;
    public id_evento: number;
    public id_tipo_certificacao: number;
    public id_situacao: number;

    //public edicao_dia_semana: EdicaoDiaSemana;
    public evento: GerenciamentoEvento;
}




// WEBPACK FOOTER //
// ./src/app/entity/edicao-model.ts